import React from "react";
import { useTranslation } from "react-i18next";
import useAppNavigate from "../../hooks/useAppNavigate";
import AppNavMockup from "../../components/widgets/AppNavMockup";
import StepRow from "../../components/widgets/StepRow";
import HelpfulCard from "../../components/widgets/HelpfulCard";
import HelpfulTipsCard from "../../components/widgets/HelpfulTipsCard";
import PageHeader from "../../components/widgets/PageHeader";
import { BlueTickIcon, GreenCheckIcon } from "../../components/ui/icons";

const ScanReceipt = () => {
  const navigate = useAppNavigate();
  const { t } = useTranslation();

  const overviewPoints = t("scanReceipt.overviewPoints", { returnObjects: true });
  const steps = t("scanReceipt.steps", { returnObjects: true });
  const tips = t("scanReceipt.tips", { returnObjects: true });

  return (
    <div className="bg-[#F2F2F7] dark:bg-[#000000] transition-colors duration-200 pb-4">
      <PageHeader
        title={t("scanReceipt.title")}
        onBack={() => navigate("/how-to-use")}
      />

      {/* Card 1 — Overview */}
      <div className="mx-4 mt-2 mb-4 rounded-2xl overflow-hidden border border-[#DEDEDE] dark:bg-[#1B1C1E] dark:border-[#1B1C1E]">
        <div className="px-4 pt-4 pb-4">
          <h2 className="font-inter font-semibold text-[18px] text-black dark:text-white mb-1">
            {t("scanReceipt.cardTitle")}
          </h2>
          <p className="text-xs lg:text-sm text-[#636363] dark:text-[#EBEBF5] dark:opacity-60 leading-relaxed mb-3 font-normal">
            {t("scanReceipt.cardDesc")}
          </p>
          <div className="flex flex-col gap-2">
            {overviewPoints.map((point, i) => (
              <div key={i} className="flex items-center gap-2">
                <BlueTickIcon />
                <span className="text-xs lg:text-sm font-normal text-black dark:text-white leading-snug">
                  {point}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Card 2 — App Mockup */}
      <AppNavMockup activeRoute="/how-to-scan-receipt" />

      {/* Section label */}
      <p className="px-4 mb-2 text-xs lg:text-sm font-semibold tracking-wide text-[#636363]  ">
        {t("scanReceipt.sectionLabel")}
      </p>

      {/* Card 3 — Steps */}
      <div className="mx-4 mb-4 rounded-2xl overflow-hidden bg-white border border-[#DEDEDE] dark:bg-[#1B1C1E] dark:border-[#1B1C1E]">
        <div className="px-4">
          {steps.map((step, i) => (
            <StepRow
              key={i}
              number={i + 1}
              title={step.title}
              desc={step.desc}
              items={step.items}
              descAfter={step.descAfter}
              optional={!!step.optional}
              isLast={i === steps.length - 1}
            />
          ))}
        </div>
      </div>

      {/* Card 4 — Helpful Tips */}
      <HelpfulTipsCard
        tips={tips}
        BulletComponent={GreenCheckIcon}
        itemAlign="items-start"
      />

      {/* Card 5 — Was this helpful? */}
      <HelpfulCard />
    </div>
  );
};

export default ScanReceipt;
